import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting } from "@nosto/preact"
import { productImagePlaceholder } from "../helpers"
import SubmitButton from "./elements/SubmitButton"

export default function Autocomplete() {
    const { products, keywords } = useResponse()
    const { format } = useCurrencyFormatting()

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }

    return (
        <div
            class="ns-autocomplete ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box"
            data-nosto-element="autocomplete"
        >
            <div class="ns-w-100">
                <div class="ns-d-flex ns-flex-column ns-flex-grow-1 gap-y-4">
                    {<div class="utility text-t-brand-foreground-secondary">
                        Top Results
                    </div>}
                    {/*keywords?.hits?.length > 0 && (
                        <div
                            class={`ns-autocomplete-keywords ns-d-flex ns-flex-column ns-col-12 ${
                                products?.hits?.length > 0 ? "ns-col-sm-4" : "ns-col-sm-12"
                            }`}
                        >
                            {/* <div class="ns-color-black ns-py-2 ns-px-4 ns-font-medium ns-font-4">
                                Keywords
                            </div>}
                            <div class="ns-d-flex ns-flex-column ns-flex-grow-1 gap-y-4">
                                <Keywords
                                    hits={keywords.hits}
                                    keywordComponent={Keyword}
                                    elementComponent={Element}
                                    keywordInCategoryComponent={KeywordInCategory}
                                />
                            </div>
                        </div>
                    )*/}
                    {products?.hits?.length > 0 && (
                        <div class="ns-autocomplete-products">
                            <div class="ns-d-flex ns-flex-column ns-align-items-start gap-y-xs">
                                {products?.hits?.map(hit => {
                                    return (
                                        <AutocompleteElement key={hit.productId} hit={hit}>
                                            <div
                                                data-url={hit.url}
                                                class="ns-d-flex flex-row ns-clickable"
                                                data-nosto-element="product"
                                            >
                                                <div class="">
                                                    <div class="ns-clipped ns-text-one-line body-l text-[0.75rem] text-t-brand-foreground-secondary hover:text-t-foreground transition-[color] duration-300 ease-out">
                                                        {hit.name}
                                                    </div>
                                                </div>
                                            </div>
                                        </AutocompleteElement>
                                    )
                                })}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement hit={hit} filter={filter} class="ns-clickable body-l text-[0.75rem]">
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}
